import axios from '@service'
import { GET_ORG_OPTIONS } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 获取 `组织` 下拉选项数据
export default async function getOrgOptionsService(payload = {}, config = {}) {
    const param = {
        ...GET_ORG_OPTIONS,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || []
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
